import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { staffCalendarAPI } from 'api/temple'
import { apiStatus } from 'shared/constants/AppEnum'
import { AppState } from 'store/reduxStore'
import { IApiState } from 'store/types'
import { StaffCalendarFilterType, StaffCalendarRowType } from 'types/api/temple'
import { selectCurrentTempleId } from './templeSlice'

type StaffCalendarStateType = {
    api: IApiState
    rows: StaffCalendarRowType[]
}

const initialState: StaffCalendarStateType = {
    api: {
        status: apiStatus.IDLE,
        error: null,
    },
    rows: [],
}

export const staffCalendarListThunk = createAsyncThunk(
    'staffCalendar/list',
    async (payload: StaffCalendarFilterType, { rejectWithValue, getState }) => {
        const templeId = payload.templeId ?? selectCurrentTempleId(getState() as AppState)
        try {
            const response = await staffCalendarAPI.list({ ...payload, templeId })
            return response.data
        } catch (err: any) {
            return rejectWithValue(err.response.data)
        }
    }
)

const staffCalendarSlice = createSlice({
    name: 'staffCalendar',
    initialState,
    reducers: {
        resetState(state) {
            state.api = {
                status: apiStatus.IDLE,
                error: null,
            }
            state.rows = []
        },
    },
    extraReducers: builder => {
        builder.addCase(staffCalendarListThunk.pending, state => {
            state.api = {
                status: apiStatus.LOADING,
                error: null,
            }
        })
        builder.addCase(staffCalendarListThunk.fulfilled, (state, action) => {
            state.api = {
                status: apiStatus.SUCCEEDED,
                error: null,
            }
            state.rows = action.payload
        })
        builder.addCase(staffCalendarListThunk.rejected, (state, action) => {
            state.api = {
                status: apiStatus.FAILED,
                error: action.payload,
            }
        })
    },
})

export default staffCalendarSlice.reducer

export const { resetState } = staffCalendarSlice.actions

export const selectStaffCalendarRows = (state: AppState) => state.staffCalendar.rows

export const selectStaffCalendarStatus = (state: AppState): IApiState => state.staffCalendar.api
